// reports actions
import axios from 'axios';
// import i18n from '@/i18n';
import types from '../../types';
/* eslint-disable */
export default {
  [types.GET_REPORTS]: async (context) => {
    try {
      await axios.get(`admin-reports/get-list`).then((res) => {
        context.commit('STORE_REPORTS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_REPORTS]: ({ commit }, payload) => {
    commit('STORE_REPORTS', payload);
  },
  [types.CLEAR_REPORTS]: (context) => {
    context.commit('CLEAR_REPORTS');
  },
  [types.SEARCH_REPORTS]: async ({commit, getters }, payload) => {
    let filter = {};
    if(Object.keys(getters.get_active_filter).length > 0) {
      filter = getters.get_active_filter;
    } else if (Object.keys(getters.get_active_tmp_filter).length > 0) {
      filter = getters.get_active_tmp_filter;
    }
    try {
      await axios.get(`admin-reports/get-list?search=${JSON.stringify(filter)}&searchTerm=${getters.get_search_term}`).then((res) => {
        commit('CLEAR_REPORTS');
        commit('STORE_REPORTS', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.GET_REPORT]: async (context, payload) => {
    try {
      await axios.get(`admin-reports/${payload}/get`).then((res) => {
        context.commit('STORE_REPORT', res.data.data);
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.ADD_REPORT]: async (context, payload) => {
    try {
      await axios.post('admin-reports/create', payload).then((res) => {
      /*  context.commit('SHOW_NOTIFICATION_BAR', {
          message: i18n.t('report_created_successfully'),
          type: 'success-window',
          iconName: 'check',
        })*/
        let iconName = 'airplane';
        let fileName = 'report.csv';

        console.log(payload.form.type)

        switch (payload.form.type) {
          case '1':
            iconName = 'truck';
            fileName = 'shipment-report.csv'
            break;
          case '2':
            iconName = 'team';
            fileName = 'contact-report.csv'
            break;
          case '3':
            iconName = 'products';
            fileName = 'item-report.csv'
            break;
        }

        console.log({
          id: res.data.data.id,
          progressId: res.data.data.progress_id,
          progressStatus: 0,
          iconName,
          fileName
        })

        context.dispatch('STORE_IN_QUEUE', {
          id: res.data.data.id,
          progressId: res.data.data.progress_id,
          progressStatus: 0,
          iconName,
          fileName
        })
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.DELETE_REPORTS]: async (context, payload) => {
    try {
      await axios.delete(`admin-reports/${payload}/delete`);
    } catch (err) {
      console.error(err);
    }
  },
  [types.DOWNLOAD_REPORT]: async (context, payload) => {
    try {
      const res = await axios.post(`admin-reports/${payload}/download`, {responseType: 'text/csv'});
       return res.data;
    } catch (err) {
      console.error(err);
    }
  },
};
